.hide {
  display: none;
}
